import { HttpResponse } from '@angular/common/http';
import {
  AuxiliaryDataFieldType,
  DropdownOptionInterface,
  GetAuxiliaryDataFieldSchemaResponseInterface as GetFieldSchemaAccountResponse,
  GetMultiAuxiliaryDataFieldSchemaResponseInterface as GetMultiFieldSchemaAccountResponse,
  ListAuxiliaryDataFieldSchemaResponseInterface as ListFieldSchemasAccountResponse,
} from '@vendasta/account-group';
import {
  AuxiliaryDataFieldSchemaInterface,
  GetAuxiliaryDataFieldSchemaResponseInterface as GetFieldSchemaUserResponse,
  GetMultiAuxiliaryDataFieldSchemaResponseInterface as GetMultiFieldSchemaUserResponse,
  ListAuxiliaryDataFieldSchemaResponseInterface as ListFieldSchemasUserResponse,
} from '@vendasta/iamv2/lib/_internal/interfaces/fields.interface';
import {
  GetAuxiliaryDataFieldSchemaResponseInterface as GetFieldSchemaProductResponse,
  GetMultiAuxiliaryDataFieldSchemaResponseInterface as GetMultiFieldSchemaProductResponse,
  ListAuxiliaryDataFieldSchemaResponseInterface as ListFieldSchemasProductResponse,
} from '@galaxy/marketplace-apps';
import {
  GetAuxiliaryDataFieldSchemaResponseInterface as GetFieldSchemaSalesOrderResponse,
  GetMultiAuxiliaryDataFieldSchemaResponseInterface as GetMultiFieldSchemaSalesOrderResponse,
  ListAuxiliaryDataFieldSchemaResponseInterface as ListFieldSchemasSalesOrderResponse,
} from '@vendasta/sales-orders';
import { Observable } from 'rxjs';
import { PagedResponseMetadataInterface } from '@vendasta/sales-orders/lib/_internal/interfaces/paging.interface';

export type ObjectType = 'business' | 'user' | 'product' | 'order' | 'task' | 'Contact' | 'Company';
export const SupportedObjectTypes = ['business', 'user', 'product', 'order', 'task', 'Contact', 'Company'];
export type ListFieldSchemasResponse =
  | ListFieldSchemasAccountResponse
  | ListFieldSchemasUserResponse
  | ListFieldSchemasProductResponse
  | ListFieldSchemasSalesOrderResponse
  | ListFieldSchemasCRMResponse;
export type GetFieldSchemaResponse =
  | GetFieldSchemaAccountResponse
  | GetFieldSchemaUserResponse
  | GetFieldSchemaProductResponse
  | GetFieldSchemaSalesOrderResponse
  | GetFieldSchemaCRMResponse;
export type GetMultiFieldSchemaResponse =
  | GetMultiFieldSchemaAccountResponse
  | GetMultiFieldSchemaUserResponse
  | GetMultiFieldSchemaProductResponse
  | GetMultiFieldSchemaSalesOrderResponse
  | GetMultiFieldSchemasCRMResponse;

export interface ListFieldSchemasCRMResponse {
  fieldSchemas?: AuxiliaryDataFieldSchemaInterface[];
  pagingMetadata?: PagedResponseMetadataInterface;
}

export interface GetFieldSchemaCRMResponse {
  fieldSchema?: AuxiliaryDataFieldSchemaInterface;
}

export interface GetMultiFieldSchemasCRMResponse {
  fieldSchemas?: AuxiliaryDataFieldSchemaInterface[];
}

export interface FieldSchema {
  partnerId?: string;
  fieldId?: string;
  fieldType?: AuxiliaryDataFieldType; // shared def in protos but re-exported from each SDK separately
  fieldName?: string;
  fieldDescription?: string;
  dropdownOptions?: DropdownOptionInterface[];
  currencyCode?: string;
  externalId?: string;
  created?: Date;
  updated?: Date;
  archived?: Date;
}

export interface UpdateFieldSchemaRequest {
  partnerId: string;
  fieldId: string;
  fieldType: AuxiliaryDataFieldType; // FIXME: the SDKs/lib shouldn't require this on updates; it's discarded because we don't allow changing the data-type (which would only make sense for very narrow things like downgrading to a string)
  fieldName?: string;
  fieldDescription?: string;
  dropdownOptions?: DropdownOptionInterface[];
  currencyCode?: string;
  externalId?: string;
}

export enum UpdateSchemaFieldMaskOptions {
  name = 'fieldName',
  description = 'fieldDescription',
  dropdownOptions = 'dropdownOptions',
  currencyCode = 'currencyCode',
  externalId = 'externalId',
}

export type UpdateSchemaFieldMask = UpdateSchemaFieldMaskOptions[];

export interface FieldSchemaIdentifier {
  fieldId?: string;
  externalId?: string;
  partnerId: string;
}

export interface AbstractAuxiliaryDataSchemaService {
  listFieldSchemas(
    partnerId: string,
    onlyArchived: boolean,
    cursor: string,
    pageSize: number,
  ): Observable<ListFieldSchemasResponse>;

  createFieldSchema(schema: FieldSchema): Observable<HttpResponse<null>>;

  updateFieldSchema(
    changes: UpdateFieldSchemaRequest,
    fieldMask: UpdateSchemaFieldMask,
  ): Observable<HttpResponse<null>>;

  getFieldSchema(id: FieldSchemaIdentifier): Observable<GetFieldSchemaResponse>;

  getMultiFieldSchema(ids: FieldSchemaIdentifier[]): Observable<GetMultiFieldSchemaResponse>;

  archiveFieldSchema(id: FieldSchemaIdentifier): Observable<HttpResponse<null>>;

  unarchiveFieldSchema(id: FieldSchemaIdentifier): Observable<HttpResponse<null>>;
}
